



import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { CHOOSE_CUSTOMER_NAME } from '@/features/auth/auth.router'
import { GET_CUSTOMER_NAME } from '@/system/store/getter-types'
@Component
export default class SwitchCustomer extends Vue {
  @Getter(GET_CUSTOMER_NAME)
  customerName!: string

  private async handleSwitchCustomer (): Promise<void> {
    this.$router.push({ name: CHOOSE_CUSTOMER_NAME })
  }
}
